<div class="errors" *ngIf="model">
    <div class="alert {{model.cssClass}}" role="alert" *ngIf="model.message && !model.modelState" [innerHtml]="model.message"></div>

    <div class="alert {{model.cssClass}}" role="alert" *ngIf="model.modelState">
        <ul class="list-unstyled" *ngFor="let item of model.modelState | keyvalue">
            <li>
                <ul class="list-unstyled">
                    <li *ngFor="let error of item.value">{{error}}</li>
                </ul>
            </li>
        </ul>
    </div>
</div>